export default __webpack_public_path__ + "maps-examples-annotation-views-thumbnail-480-6effbc65d74b8e5b6b2cfe9420e737d6.webp";